import React from "react";
import { ViewLoanPayments } from "../components/Loan";
import { Loading } from "../components/Loader";
import AppClass from "../AppClass";
import moment from "moment";
import { Modal, Header, Body, Footer } from "../components/Modal";
import toastMessage from "../components/toastMessage";
import { Pagination } from "../components/Pagination";
import { numberWithCommas } from "../configs/formatCurrency";
import Axios from "axios";
import HOST_URL from "../configs/api";
import CustomInput from "../components/BasicComponents/CustomInput";

class LoanDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loanData: {},
      status: "",
      apps: props.apps,
      sacco: "",
      isSubmitting: false,
      payments: [],
      id: "",
      show: false,
      files: [],
      loan_id: "",
      start_date: moment().subtract("365", "days").format("YYYY-MM-DD"),
      end_date: moment().add("1", "d").format("YYYY-MM-DD"),
      summary: {},
      page: 1,
      limit: 50,
      topUpAmount: "",
      showTopUpConfirmation: false,
      topUpError: "",
      isFocused: false,
      showInterestModal: false,
      selectedInterest: null,
      interestDate: moment().format("YYYY-MM-DD"),
      interestDescription: "",
      interestPrincipalAmount: 0,
      interestAmount: 0,
      showTransactionModal: false,
      transactionDate: moment().format("YYYY-MM-DD"),
      transactionAmount: "",
      transactionError: "",
      transactionReference: "",
    };
  }

  componentDidMount() {
    this.setState(
      {
        loan_id: this.props.somethingID,
      },
      () => {
        this.get_loan_by_id(true);
      }
    );
  }

  get_loan_by_id(isLoading) {
    this.setState({ isLoading });
    const { loan_id } = this.state;

    AppClass.get_loan_by_loan_id(loan_id)
      .then((res) => {
        const loanData = res.data?.data;

        this.setState({
          isLoading: false,
          status: loanData.status,
          id: loanData._id,
          loanData,
        });

        this.getPayments();
      })
      .catch((err) => {
        toastMessage(
          "error",
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          'Failed to get loan details'
        );
        this.setState({
          isLoading: false,
        });
      });
  }

  getPayments(isLoadingPayment) {
    if (!this.state?.loanData?._id) {
      this.setState({
        isLoadingPayment: false,
        payments: [],
        summary: {},
      });
      return;
    }

    const { start_date, end_date, page, limit, loanData } = this.state;

    this.setState({
      isLoadingPayment,
    });

    const body = {
      loan_id: loanData._id,
      page_number: page,
      page_limit: limit,
    };

    if (start_date && end_date) {
      body["from_date"] = start_date;
      body["to_date"] = end_date;
    }

    // AppClass.get_repaymentdata(body)
    //   .then((res) => {
    //     const { data, summary } = res.data;

    //     this.setState({
    //       isLoadingPayment: false,
    //       payments: data,
    //       summary,
    //     });
    //   })
    //   .catch((err) => {
    //     toastMessage("error",
    //       err?.response?.data?.message ||
    //       err?.response?.data?.error ||
    //       err?.messsage ||
    //       'Failed to get payments'
    //     );
    //     this.setState({
    //       isLoadingPayment: false,
    //     });
    //   });
  }

  onChangeStartingDate(e) {
    this.setState({ start_date: e.target.value }, () => {
      this.getPayments(true);
    });
  }

  onChangeEndDate(e) {
    this.setState({ end_date: e.target.value }, () => {
      this.getPayments(true);
    });
  }

  onDelete(e, id) {
    e.preventDefault();
    if (window.confirm("Are you sure to delete this payment?")) {
      this.delete_payment(id);
    }
  }

  delete_payment(id) {
    const input_data = {
      id,
      model: "loan",
    };

    const errors = AppClass.validate_form(input_data);

    if (!Object.keys(errors)?.length) {
      AppClass.delete_data(input_data)
        .then((data) => {
          this.setState({
            isLoading: false,
          });
          this.setState({
            payments: [],
          });
          this.get_loan_by_id(this.props.somethingID);
        })
        .catch((err) => {
          this.setState({ isSubmitting: false });
          toastMessage(
            "error",
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.messsage ||
            'Failed to delete payment'
          );
        });
    } else {
      toastMessage(
        "error",
        errors,
        'Failed to delete payment'
      );
    }
  }

  handleOpenModal = (modal, loanData, selectedItem = null) => {
    if (modal === 'showInterestModal') {
      this.setState({
        showInterestModal: true,
        selectedInterest: selectedItem,
        interestDate: selectedItem ? moment(selectedItem.interest_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        interestDescription: selectedItem?.description || "",
        interestPrincipalAmount: selectedItem?.principal_amount || "",
        interestAmount: selectedItem?.interest_amount || "",
      });
    } else if (modal === 'showTopUpModal') {
      this.setState({
        showTopUpModal: true,
      });
    } else if (modal === 'showTransactionModal') {
      const autoReference = `MAN${moment().format("YYYYMMDD")}${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`;
      this.setState({
        showTransactionModal: true,
        transactionDate: moment().format("YYYY-MM-DD"),
        transactionAmount: "",
        transactionError: "",
        transactionReference: autoReference,
      });
    } else {
      this.setState({
        [modal]: true,
      });
    }
  };

  handleClose = (modal) => {
    if (modal === 'showInterestModal') {
      this.setState({
        showInterestModal: false,
        selectedInterest: null,
        interestDate: moment().format("YYYY-MM-DD"),
        interestDescription: "",
        interestPrincipalAmount: "",
        interestAmount: "",
        interestError: "",
      });
    } else if (modal === 'showTransactionModal') {
      this.setState({
        showTransactionModal: false,
        transactionDate: moment().format("YYYY-MM-DD"),
        transactionAmount: "",
        transactionError: "",
        transactionReference: "",
      });
    } else {
      this.setState({ [modal]: false });
    }
  };

  handleChangeLimit(e) {
    this.setState(
      {
        limit: e.target.value,
        page: 1,
      },
      () => {
        this.getPayments(true);
      }
    );
  }

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getPayments(true);
      }
    );
  }

  handleTopUpAmountChange = (e) => {
    this.setState({ topUpAmount: e.target.value });
  }

  validateTopUpAmount = () => {
    const { topUpAmount } = this.state;
    if (!topUpAmount) {
      this.setState({ topUpError: "Amount is required" });
      return false;
    }
    if (isNaN(topUpAmount) || parseFloat(topUpAmount) <= 0) {
      this.setState({ topUpError: "Please enter a valid amount" });
      return false;
    }
    this.setState({ topUpError: "" });
    return true;
  }

  showTopUpConfirmation = () => {
    if (this.validateTopUpAmount()) {
      this.setState({ showTopUpConfirmation: true });
    }
  }

  submitTopUp = async () => {
    try {
      this.setState({ isSubmitting: true });

      await Axios.patch(
        `${HOST_URL.url}/loans-v2/${this.state.loanData._id}/topup`,
        { amount: parseFloat(this.state.topUpAmount) },
        {
          headers: {
            authorization: `Bearer ${this.props.ztoken}`,
          },
        }
      );

      this.setState({ 
        showTopUpModal: false, 
        showTopUpConfirmation: false,
        topUpAmount: "",
        isSubmitting: false
      }, () => {
        toastMessage("success", "Loan top-up completed successfully");
        this.get_loan_by_id(true);
      });

    } catch (error) {
      this.setState({ isSubmitting: false });
      toastMessage(
        "error", 
        error?.response?.data?.error || "Failed to process loan top-up"
      );
    }
  };

  validateInterest = () => {
    const { interestDate, interestDescription, interestPrincipalAmount, interestAmount } = this.state;
    
    if (!interestDate || !interestDescription || !interestPrincipalAmount || !interestAmount) {
      this.setState({ interestError: "All fields are required" });
      return false;
    }
    
    if (isNaN(interestPrincipalAmount) || parseFloat(interestPrincipalAmount) <= 0) {
      this.setState({ interestError: "Please enter a valid principal amount" });
      return false;
    }
    
    if (isNaN(interestAmount) || parseFloat(interestAmount) <= 0) {
      this.setState({ interestError: "Please enter a valid interest amount" });
      return false;
    }

    this.setState({ interestError: "" });
    return true;
  };

  submitInterest = async () => {
    if (!this.validateInterest()) return;

    try {
      this.setState({ isSubmitting: true });

      const method = this.state.selectedInterest ? "PATCH" : "POST";
      const url = this.state.selectedInterest 
        ? `${HOST_URL.url}/loan-interests/${this.state.selectedInterest._id}`
        : `${HOST_URL.url}/loan-interests`;

      await Axios({
        method,
        url,
        data: {
          loan_id: this.state.loanData._id,
          interest_date: this.state.interestDate,
          description: this.state.interestDescription,
          principal_amount: parseFloat(this.state.interestPrincipalAmount),
          interest_amount: parseFloat(this.state.interestAmount),
        },
        headers: {
          authorization: `Bearer ${this.props.ztoken}`,
        },
      });

      this.setState({ 
        showInterestModal: false,
        selectedInterest: null,
        interestDate: moment().format("YYYY-MM-DD"),
        interestDescription: "",
        interestPrincipalAmount: "",
        interestAmount: "",
        interestError: "",
        isSubmitting: false
      }, () => {
        toastMessage("success", "Interest record saved successfully");
        this.get_loan_by_id(true);
      });

    } catch (error) {
      this.setState({ isSubmitting: false });
      toastMessage(
        "error", 
        error?.response?.data?.error || "Failed to save interest record"
      );
    }
  };

  handleDeleteInterest = async (interestId) => {
    if (!window.confirm('Are you sure you want to delete this interest record?')) {
      return;
    }

    try {
      await Axios({
        method: "DELETE",
        url: `${HOST_URL.url}/loan-interests/${interestId}`,
        headers: {
          authorization: `Bearer ${this.props.ztoken}`,
        },
      });

      toastMessage("success", "Interest record deleted successfully");
      this.get_loan_by_id(true);
    } catch (error) {
      toastMessage(
        "error",
        error?.response?.data?.error || "Failed to delete interest record"
      );
    }
  };

  validateTransaction = () => {
    const { transactionDate, transactionAmount, transactionReference } = this.state;
    
    if (!transactionDate || !transactionAmount || !transactionReference) {
      this.setState({ transactionError: "All fields are required" });
      return false;
    }
    
    if (isNaN(transactionAmount) || parseFloat(transactionAmount) <= 0) {
      this.setState({ transactionError: "Please enter a valid amount" });
      return false;
    }

    this.setState({ transactionError: "" });
    return true;
  };

  submitTransaction = async () => {
    if (!this.validateTransaction()) return;

    try {
      this.setState({ isSubmitting: true });

      // Create a moment object from the selected date
      const selectedDate = moment(this.state.transactionDate);
      
      // Get current local time
      const now = moment();
      
      // Set the time of the selected date to current local time
      selectedDate.hours(now.hours())
                  .minutes(now.minutes())
                  .seconds(now.seconds());
      
      // Convert to UTC while preserving the local time
      const utcDate = selectedDate.utc();

      await Axios({
        method: "POST",
        url: `${HOST_URL.url}/loan-transactions`,
        data: {
          app_id: this.state.loanData.app_id,
          member_id: this.state.loanData.member._id,
          source: "MANUAL",
          type: "PAYMENT",
          transaction_date: utcDate.toDate(),
          reference_number: this.state.transactionReference,
          amount: parseFloat(this.state.transactionAmount),
        },
        headers: {
          authorization: `Bearer ${this.props.ztoken}`,
        },
      });

      // Close modal and reset form
      this.setState({ 
        showTransactionModal: false,
        transactionDate: moment().format("YYYY-MM-DD"),
        transactionAmount: "",
        transactionError: "",
        transactionReference: "",
        isSubmitting: false
      });

      // Show success message
      toastMessage("success", "Transaction added successfully");

      // Refetch loan data and payments
      await Promise.all([
        this.get_loan_by_id(true),
        this.getPayments(true)
      ]);

    } catch (error) {
      this.setState({ isSubmitting: false });
      toastMessage(
        "error", 
        error?.response?.data?.error || "Failed to add transaction"
      );
    }
  };

  render() {
    const {
      isLoading,
      message,
      loanData
    } = this.state;

    return (
      <div className="content-cont">
        {isLoading ? (
          <Loading message={message} icon="fa fa-spinner fa-spin" />
        ) : (
          <>
            <div style={{ paddingTop: 15 }}>
              <ViewLoanPayments
                loanData={this.state.loanData}
                handleOpenModal={this.handleOpenModal}
                handleDeleteInterest={this.handleDeleteInterest}
              />
              <Pagination
                totalItemsCount={this.state.payments?.length}
                page={this.state.page}
                limit={this.state.limit}
                handleChangeLimit={this.handleChangeLimit.bind(this)}
                handlePagination={this.handlePagination.bind(this)}
              />
            </div>
          </>
        )}

        <Modal show={this.state.showTopUpModal}>
          <Header>
            <h5 className="modal-title" style={{ fontWeight: 600 }}>
              Loan Top-Up
              <small style={{ 
                color: '#6c757d', 
                marginLeft: '8px', 
                fontWeight: 600,
                fontSize: '16px',
                backgroundColor: '#f0f0f0',
                padding: '4px 10px',
                borderRadius: '4px',
                display: 'inline-block'
              }}>{this.props.somethingID}</small>
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => this.handleClose("showTopUpModal")}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Header>
          <Body>
            {!this.state.showTopUpConfirmation ? (
              <div style={{ padding: '0 5px' }}>
                <p style={{ color: '#6c757d', marginBottom: '20px' }}>
                  Top up <span style={{ 
                    fontWeight: 600, 
                    color: '#F79222',
                    backgroundColor: '#fff8e1',
                    padding: '2px 6px',
                    borderRadius: '3px'
                  }}>{this.state.loanData?.member?.user_name + "'s" || "your"}</span> loan with additional funds.
                </p>
                
                <div style={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '8px', 
                  marginBottom: '20px',
                  border: '1px solid #dee2e6',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ padding: '15px' }}>
                    <div style={{ fontSize: '13px', color: '#6c757d', marginBottom: '5px' }}>Current Balance</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ fontWeight: 700, marginBottom: 0 }}>KES {numberWithCommas(loanData?.balance)}</h3>
                      {this.state.loanData && (
                        <span style={{ 
                          backgroundColor: '#fff8e1', 
                          color: '#F79222', 
                          padding: '4px 10px', 
                          borderRadius: '20px', 
                          fontSize: '12px',
                          fontWeight: 600,
                          display: 'inline-flex',
                          alignItems: 'center',
                          border: '1px solid #F79222'
                        }}>
                          <span style={{
                            width: '6px',
                            height: '6px',
                            backgroundColor: '#F79222',
                            borderRadius: '50%',
                            marginRight: '5px',
                            display: 'inline-block'
                          }}></span>
                          {loanData?.status || "Active"}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                
                <div style={{ marginBottom: '20px' }}>
                  <CustomInput
                    type="number"
                    label="Top-Up Amount"
                    unit="KES"
                    name="topUpAmount"
                    value={this.state.topUpAmount}
                    onChange={this.handleTopUpAmountChange}
                    placeholder="Enter amount to top-up"
                    error={this.state.topUpError}
                    help={true}
                  />
                </div>
                
                {this.state.topUpAmount && !isNaN(this.state.topUpAmount) && (
                  <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    borderRadius: '4px', 
                    marginBottom: '20px',
                    borderLeft: '4px solid #F79222',
                    border: '1px solid #dee2e6',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ padding: '15px' }}>
                      <div style={{ fontSize: '13px', color: '#6c757d', marginBottom: '5px' }}>New Balance After Top-Up</div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h3 style={{ fontWeight: 700, marginBottom: 0 }}>KES {numberWithCommas(parseFloat(loanData?.balance) + parseFloat(this.state.topUpAmount))}</h3>
                        <span style={{ color: '#F79222' }}>
                          <i className="fa fa-arrow-up" style={{ marginRight: '3px' }}></i> 
                          {Math.round((parseFloat(this.state.topUpAmount) / (parseFloat(loanData?.balance) || 1)) * 100)}%
                        </span>
                      </div>
                      <div style={{ marginTop: '10px', backgroundColor: '#e9ecef', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
                        <div 
                          style={{
                            width: '100%',
                            height: '100%',
                            backgroundColor: '#F79222'
                          }}>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
                <div style={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '8px', 
                  marginBottom: '15px',
                  border: '1px solid #dee2e6',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ padding: '15px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <i className="fa fa-info-circle" style={{ color: '#F79222', marginRight: '8px' }}></i>
                      <span style={{ fontWeight: 600 }}>Important Information</span>
                    </div>
                    <ul style={{ paddingLeft: '20px', marginBottom: 0, color: '#6c757d' }}>
                      <li style={{ marginBottom: '5px' }}>This will update the loan balance immediately upon confirmation</li>
                      <li style={{ marginBottom: '5px' }}>No additional interest will be applied to the top-up amount</li>
                      <li>Additional terms and conditions may apply</li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ padding: '0 5px' }}>
                <div style={{ 
                  backgroundColor: '#fff8e1', 
                  color: '#F79222', 
                  padding: '12px 15px', 
                  borderRadius: '4px', 
                  marginBottom: '20px',
                  border: '1px solid #F79222'
                }}>
                  <i className="fa fa-info-circle" style={{ marginRight: '8px' }}></i>
                  Please review and confirm your top-up request.
                </div>
                
                <div style={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '4px', 
                  marginBottom: '15px',
                  border: '1px solid #dee2e6',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ padding: '15px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                      <div style={{ color: '#6c757d' }}>Loan ID:</div>
                      <div style={{ fontWeight: 600 }}>{this.props.somethingID}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                      <div style={{ color: '#6c757d' }}>Current Balance:</div>
                      <div style={{ fontWeight: 600 }}>KES {numberWithCommas(loanData?.balance)}</div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                      <div style={{ color: '#6c757d' }}>Top-Up Amount:</div>
                      <div style={{ fontWeight: 600 }}>KES {numberWithCommas(this.state.topUpAmount)}</div>
                    </div>
                    <hr style={{ margin: '12px 0' }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <div style={{ color: '#6c757d' }}>New Total Balance:</div>
                      <div style={{ fontWeight: 600, color: '#F79222' }}>
                        KES {numberWithCommas(parseFloat(loanData?.balance) + parseFloat(this.state.topUpAmount))}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{ 
                  backgroundColor: '#fff8e1', 
                  color: '#F79222', 
                  padding: '12px 15px', 
                  borderRadius: '4px',
                  border: '1px solid #F79222'
                }}>
                  <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                  By confirming, you agree to the terms and conditions of the top-up.
                </div>
              </div>
            )}
          </Body>
          <Footer>
            {!this.state.showTopUpConfirmation ? (
              <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <button
                  type="button"
                  className="btn-cancel"
                  style={{ 
                    backgroundColor: '#f8f9fa',
                    borderColor: '#ddd',
                    color: '#333',
                    padding: '6px 12px', 
                    borderRadius: '4px',
                    marginRight: '8px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease',
                    border: '1px solid #ddd'
                  }}
                  onClick={() => this.handleClose("showTopUpModal")}
                >
                  <i className="fa fa-times" style={{ marginRight: '5px' }}></i> Cancel
                </button>
                <button
                  type="button"
                  className="btn-send"
                  style={{ 
                    backgroundColor: '#F79222', 
                    border: 'none', 
                    color: 'white', 
                    padding: '6px 12px', 
                    borderRadius: '4px',
                    opacity: (!this.state.topUpAmount || isNaN(this.state.topUpAmount)) ? 0.65 : 1,
                    cursor: (!this.state.topUpAmount || isNaN(this.state.topUpAmount)) ? 'not-allowed' : 'pointer',
                    fontWeight: 600,
                    transition: 'all 0.2s ease'
                  }}
                  onClick={this.showTopUpConfirmation}
                  disabled={!this.state.topUpAmount || isNaN(this.state.topUpAmount)}
                >
                  Next <i className="fa fa-arrow-right" style={{ marginLeft: '5px' }}></i>
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <button
                  type="button"
                  className="btn-cancel"
                  style={{ 
                    backgroundColor: '#f8f9fa',
                    borderColor: '#ddd',
                    color: '#333',
                    padding: '6px 12px', 
                    borderRadius: '4px',
                    marginRight: '8px',
                    fontWeight: 500,
                    transition: 'all 0.2s ease',
                    border: '1px solid #ddd'
                  }}
                  onClick={() => this.setState({ showTopUpConfirmation: false })}
                  disabled={this.state.isSubmitting}
                >
                  <i className="fa fa-arrow-left" style={{ marginRight: '5px' }}></i> Back
                </button>
                <button
                  type="button"
                  className="btn-send"
                  style={{ 
                    backgroundColor: '#F79222', 
                    border: 'none', 
                    color: 'white', 
                    padding: '6px 12px', 
                    borderRadius: '4px',
                    fontWeight: 600,
                    transition: 'all 0.2s ease'
                  }}
                  onClick={this.submitTopUp}
                  disabled={this.state.isSubmitting}
                >
                  {this.state.isSubmitting ? (
                    <>
                      <i className="fa fa-spinner fa-spin" style={{ marginRight: '5px' }}></i>
                      Processing...
                    </>
                  ) : (
                    'Confirm Top-Up'
                  )}
                </button>
              </div>
            )}
          </Footer>
        </Modal>

        {/* Interest Modal */}
        <Modal show={this.state.showInterestModal}>
          <Header>
            <h5 className="modal-title" style={{ fontWeight: 600 }}>
              {this.state.selectedInterest ? 'Edit' : 'Add'} Loan Interest
              <small style={{ 
                color: '#6c757d', 
                marginLeft: '8px', 
                fontWeight: 600,
                fontSize: '16px',
                backgroundColor: '#f0f0f0',
                padding: '4px 10px',
                borderRadius: '4px',
                display: 'inline-block'
              }}>{this.props.somethingID}</small>
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => this.handleClose("showInterestModal")}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Header>
          <Body>
            <div style={{ padding: '0 5px' }}>
              <div className="">
                <CustomInput
                  type="date"
                  label="Interest Date"
                  name="interestDate"
                  value={this.state.interestDate}
                  onChange={(e) => this.setState({ interestDate: e.target.value })}
                  placeholder="Enter interest date"
                />
              </div>

              <div className="">
                <CustomInput
                  label="Description"
                  name="interestDescription"
                  value={this.state.interestDescription}
                  onChange={(e) => this.setState({ interestDescription: e.target.value })}
                  placeholder="Enter Description e.g. Aug 2025 Interest"
                />
              </div>

              <div className="">
                <CustomInput
                  label="Principal Amount"
                  unit="KES"
                  type="number"
                  name="interestPrincipalAmount"
                  value={this.state.interestPrincipalAmount}
                  onChange={(e) => this.setState({ interestPrincipalAmount: e.target.value })}
                  placeholder="Enter Principal Amount"
                  error={this.state.interestError}
                />
              </div>

              <div className="">
                <CustomInput
                  label="Interest Amount"
                  unit="KES"
                  type="number"
                  name="interestAmount"
                  value={this.state.interestAmount}
                  onChange={(e) => this.setState({ interestAmount: e.target.value })}
                  placeholder="Enter Interest Amount"
                  error={this.state.interestError}
                />
              </div>
            </div>
          </Body>
          <Footer>
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <button
                type="button"
                className="btn-cancel"
                style={{ 
                  backgroundColor: '#f8f9fa',
                  borderColor: '#ddd',
                  color: '#333',
                  padding: '6px 12px', 
                  borderRadius: '4px',
                  marginRight: '8px',
                  fontWeight: 500,
                  transition: 'all 0.2s ease',
                  border: '1px solid #ddd'
                }}
                onClick={() => this.handleClose("showInterestModal")}
              >
                <i className="fa fa-times" style={{ marginRight: '5px' }}></i> Cancel
              </button>
              <button
                type="button"
                className="btn-send"
                style={{ 
                  backgroundColor: '#F79222', 
                  border: 'none', 
                  color: 'white', 
                  padding: '6px 12px', 
                  borderRadius: '4px',
                  fontWeight: 600,
                  transition: 'all 0.2s ease'
                }}
                onClick={this.submitInterest}
                disabled={this.state.isSubmitting}
              >
                {this.state.isSubmitting ? (
                  <>
                    <i className="fa fa-spinner fa-spin" style={{ marginRight: '5px' }}></i>
                    Processing...
                  </>
                ) : (
                  'Save Interest Record'
                )}
              </button>
            </div>
          </Footer>
        </Modal>

        {/* Transaction Modal */}
        <Modal show={this.state.showTransactionModal}>
          <Header>
            <h5 className="modal-title" style={{ fontWeight: 600 }}>
              Add Loan Payment
              <small style={{ 
                color: '#6c757d', 
                marginLeft: '8px', 
                fontWeight: 600,
                fontSize: '16px',
                backgroundColor: '#f0f0f0',
                padding: '4px 10px',
                borderRadius: '4px',
                display: 'inline-block'
              }}>{this.props.somethingID}</small>
            </h5>
            <button
              type="button"
              className="close"
              onClick={() => this.handleClose("showTransactionModal")}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Header>
          <Body>
            <div style={{ padding: '0 5px' }}>
              <div style={{ 
                backgroundColor: '#f8f9fa', 
                borderRadius: '8px', 
                marginBottom: '20px',
                border: '1px solid #dee2e6',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}>
                <div style={{ padding: '15px' }}>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginBottom: '5px' }}>Current Balance</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ fontWeight: 700, marginBottom: 0 }}>KES {numberWithCommas(loanData?.balance)}</h3>
                    {this.state.loanData && (
                      <span style={{ 
                        backgroundColor: '#fff8e1', 
                        color: '#F79222', 
                        padding: '4px 10px', 
                        borderRadius: '20px', 
                        fontSize: '12px',
                        fontWeight: 600,
                        display: 'inline-flex',
                        alignItems: 'center',
                        border: '1px solid #F79222'
                      }}>
                        <span style={{
                          width: '6px',
                          height: '6px',
                          backgroundColor: '#F79222',
                          borderRadius: '50%',
                          marginRight: '5px',
                          display: 'inline-block'
                        }}></span>
                        {loanData?.status || "Active"}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="" style={{ marginBottom: '20px' }}>
                <CustomInput
                  type="date"
                  label="Payment Date"
                  name="transactionDate"
                  value={this.state.transactionDate}
                  onChange={(e) => this.setState({ transactionDate: e.target.value })}
                  placeholder="Enter payment date"
                />
              </div>

              <div className="" style={{ marginBottom: '20px' }}>
                <CustomInput
                  label="Reference Number"
                  name="transactionReference"
                  value={this.state.transactionReference}
                  onChange={(e) => this.setState({ transactionReference: e.target.value })}
                  placeholder="Enter reference number"
                  help={true}
                />
              </div>

              <div className="" style={{ marginBottom: '20px' }}>
                <CustomInput
                  label="Payment Amount"
                  unit="KES"
                  type="number"
                  name="transactionAmount"
                  value={this.state.transactionAmount}
                  onChange={(e) => this.setState({ transactionAmount: e.target.value })}
                  placeholder="Enter payment amount"
                  error={this.state.transactionError}
                />
              </div>

              {this.state.transactionAmount && !isNaN(this.state.transactionAmount) && (
                <div style={{ 
                  backgroundColor: '#f8f9fa', 
                  borderRadius: '4px', 
                  marginBottom: '20px',
                  borderLeft: '4px solid #F79222',
                  border: '1px solid #dee2e6',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                }}>
                  <div style={{ padding: '15px' }}>
                    <div style={{ fontSize: '13px', color: '#6c757d', marginBottom: '5px' }}>New Balance After Payment</div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <h3 style={{ fontWeight: 700, marginBottom: 0 }}>KES {numberWithCommas(parseFloat(loanData?.balance) - parseFloat(this.state.transactionAmount))}</h3>
                      <span style={{ color: '#F79222' }}>
                        <i className="fa fa-arrow-down" style={{ marginRight: '3px' }}></i> 
                        {Math.round((parseFloat(this.state.transactionAmount) / (parseFloat(loanData?.balance) || 1)) * 100)}%
                      </span>
                    </div>
                    <div style={{ marginTop: '10px', backgroundColor: '#e9ecef', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
                      <div 
                        style={{
                          width: '100%',
                          height: '100%',
                          backgroundColor: '#F79222'
                        }}>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Body>
          <Footer>
            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <button
                type="button"
                className="btn-cancel"
                style={{ 
                  backgroundColor: '#f8f9fa',
                  borderColor: '#ddd',
                  color: '#333',
                  padding: '6px 12px', 
                  borderRadius: '4px',
                  marginRight: '8px',
                  fontWeight: 500,
                  transition: 'all 0.2s ease',
                  border: '1px solid #ddd'
                }}
                onClick={() => this.handleClose("showTransactionModal")}
              >
                <i className="fa fa-times" style={{ marginRight: '5px' }}></i> Cancel
              </button>
              <button
                type="button"
                className="btn-send"
                style={{ 
                  backgroundColor: '#F79222', 
                  border: 'none', 
                  color: 'white', 
                  padding: '6px 12px', 
                  borderRadius: '4px',
                  fontWeight: 600,
                  transition: 'all 0.2s ease'
                }}
                onClick={this.submitTransaction}
                disabled={this.state.isSubmitting}
              >
                {this.state.isSubmitting ? (
                  <>
                    <i className="fa fa-spinner fa-spin" style={{ marginRight: '5px' }}></i>
                    Processing...
                  </>
                ) : (
                  'Add Payment'
                )}
              </button>
            </div>
          </Footer>
        </Modal>
      </div>
    );
  }
}

export default LoanDetails;
